import Constants from "Components/MessageToaster/Constants";
import { IShiftController } from "Interfaces/Controllers/IShiftController";
import { inject, injectable } from "inversify";
import { Dispatch } from "react";
import Types from "ServiceProvider/Types";
import i18n from "Translations/i18n";
import { ActionTypes as MessageActionTypes, IShowMessageToasterAction } from "../MessageToaster/MessageToasterActionTypes";
import { ActionTypes, ShiftActions } from "./ShiftActionTypes";

export interface IShiftAction {
    hasAreaShiftsForCompanyAsync(): any;
    getCompanyShiftsAsync(): any;
    getAreaShiftsAsync(areaId: number): any;
}

@injectable()
export class ShiftAction implements IShiftAction {
    private shiftController: IShiftController;

    public constructor(
        @inject(Types.IShiftController) shiftController: IShiftController) {
        this.shiftController = shiftController;
    }

    public hasAreaShiftsForCompanyAsync() {
        return async (dispatch: Dispatch<ShiftActions | IShowMessageToasterAction>) => {

            try {
                const hasAreaShifts = await this.shiftController.hasAreaShiftsForCompanyAsync();

                dispatch({
                    type: ActionTypes.HAS_AREA_SHIFTS_RETRIEVED,
                    hasAreaShifts
                });
            }
            catch (ex) {
                dispatch({
                    type: MessageActionTypes.SHOW_MESSAGE,
                    data: { type: Constants.MESSAGE_TYPE_DANGER, text: i18n.t("shifts.errors.retrievingHasAreaShifts") }
                });
            }
        };
    }

    public getCompanyShiftsAsync() {
        return async (dispatch: Dispatch<ShiftActions | IShowMessageToasterAction>) => {

            try {
                const companyShifts = await this.shiftController.getCompanyShiftsAsync();

                dispatch({
                    type: ActionTypes.COMPANY_SHIFTS_RETRIEVED,
                    companyShifts
                });
            }
            catch (ex) {
                dispatch({
                    type: MessageActionTypes.SHOW_MESSAGE,
                    data: { type: Constants.MESSAGE_TYPE_DANGER, text: i18n.t("shifts.errors.retrievingCompanyShifts") }
                });
            }
        };
    }

    public getAreaShiftsAsync(areaId: number) {
        return async (dispatch: Dispatch<ShiftActions | IShowMessageToasterAction>) => {

            try {
                const areaShifts = await this.shiftController.getAreaShiftsAsync(areaId);

                dispatch({
                    type: ActionTypes.AREA_SHIFTS_RETRIEVED,
                    areaShifts
                });
            }
            catch (ex) {
                dispatch({
                    type: MessageActionTypes.SHOW_MESSAGE,
                    data: { type: Constants.MESSAGE_TYPE_DANGER, text: i18n.t("shifts.errors.retrievingAreaShifts") }
                });
            }
        };
    }
}


// WEBPACK FOOTER //
// ./src/Store/Shifts/ShiftAction.ts